import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CaseResult from "@/pages/CaseResult";
import { Checkout, PaymentSuccess, PaymentCancel } from "@/pages/Payments";
import Vault from "@/pages/Vault";
import Admin from "@/pages/Admin";
import Concours from "@/pages/Concours";
import PublicDemo from "@/pages/PublicDemo";
import PanicPage from "@/pages/PanicPage";
import Timeline from "@/pages/Timeline";
import PreInstruction from "@/pages/PreInstruction";
import DossierFlashPage from "@/pages/DossierFlashPage";
import { FichesIndex, FicheDetail } from "@/pages/Fiches";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/concours" element={<Concours />} />
      <Route path="/demo/:caseId" element={<PublicDemo />} />
      <Route path="/meteo" element={<PanicPage />} />
      <Route path="/timeline" element={<Timeline />} />
      <Route path="/timeline/:caseId" element={<Timeline />} />
      <Route path="/vault" element={<Vault />} />
      <Route path="/fiches" element={<FichesIndex />} />
      <Route path="/fiches/:ficheId" element={<FicheDetail />} />
      <Route path="/preinstruction" element={<PreInstruction />} />
      <Route path="/dossier/:dossierId" element={<DossierFlashPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/citoyen" element={<Dashboard />} />
      <Route path="/dashboard/pro" element={<Dashboard />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/case/:caseId" element={<CaseResult />} />
      <Route path="/checkout/:lookupKey" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}
